import axios from 'axios';

async function setUserPreferences(user, preferences) {
  var _a;
  const preparedPreferences = {
    userID: user.id,
    userInstitutionID: ((_a = user.institution) == null ? void 0 : _a.id) ?? "",
    system: "portal",
    textToSpeech: {
      voice: mapGenderToAPIGender(preferences.speechSynthesis.gender),
      speed: preferences.speechSynthesis.speed
    },
    settings: [
      {
        device: 0,
        background: 0,
        view: 0,
        fontType: preferences.font
      }
    ]
  };
  if (preferences.objectId) {
    preparedPreferences.objectID = preferences.objectId;
  }
  const res = await axios.request({
    // ... if the objectID doesn't exist on our local preferences, that means
    // we're going to create user preferences for the first time.
    method: !preferences.objectId ? "POST" : "PUT",
    url: `${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/Preferences`,
    data: preparedPreferences
  });
  return res.data.objectID ?? preferences.objectId;
}
function mapGenderToAPIGender(gender) {
  switch (gender) {
    case "male":
      return "Male";
    case "female":
      return "Female";
    default:
      return "NotSet";
  }
}

export { setUserPreferences };
//# sourceMappingURL=request.set-user-preferences.js.map
